<template>
  <div class="newVue">
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else>
      <v-subheader>{{ $tc('agents', agents.length, { count: agents.length }) }}</v-subheader>
      <v-expansion-panel>
        <v-expansion-panel-content
          v-for="(agent,i) in agents"
          :key="i"
        >
          <div slot="header" class="listeAgentsManagement">
            <wz-avatar
              :username="agent.name"
              :src="`${domaine}/media/user/small/${agent.id}_avatar.jpg`"
              size="35px"
            ></wz-avatar>
            {{ agent.name }}
            {{ isItMe(agent.id) ? '(' + $t('me') + ')' : '' }}
          </div>
          <v-card>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-switch
                      v-if="!isAdmin(agent.rights)"
                      :label="$tc('agents', 1, {count: ''}) + ' ' + $t('enabled') + '?'"
                      v-model="agent.activity"
                      color="primary"
                      :disabled="isItMe(agent.id)"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                      :items="rights"
                      v-model="agent.rights"
                      :label="$tc('rights', 2, { count: '' }) | cap"
                      menu-props="auto"
                      :disabled="isItMe(agent.id) && isAdmin(agent.rights) && !$store.state._User.entId != '5'"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-switch
                      v-if="!isAdmin(agent.rights)"
                      label="Est un chatBot ?"
                      v-model="agent.isbot"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 v-show="agent.isbot">
                    <v-text-field
                      v-model="agent.botid"
                      label="Référence du bot"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="agent.firstname"
                      :label="$t('firstName') | cap"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="agent.lastname"
                      :label="$t('lastName') | cap"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="agent.job"
                      :label="$t('job') | cap"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      disabled
                      v-model="agent.email"
                      :label="$t('contactEmail') | cap"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              <div v-show="!agent.isbot">  
                <v-layout row wrap v-if="!isAdmin(agent.rights)">
                  <v-flex xs12>
                    <v-subheader>{{$t('chatMax') | cap }} : {{ agent.chatmax }}</v-subheader>
                  </v-flex>
                  <v-flex xs12>
                    <v-slider
                      :disabled="testBrideStatus('compte_conseillers_chat_max')"
                      min="1"
                      max="4"
                      ticks
                      v-model="agent.chatmax"
                      thumb-label
                      hide-details
                    ></v-slider>
                  </v-flex>
                </v-layout>

                <span v-if="brideMenu('compte_conseillers_transfert') === '1'">
                <v-layout row wrap v-if="!isAdmin(agent.rights)">
                  <v-flex xs12>
                    <v-subheader>{{ $t('txtDelaiTransfert') | cap }} : {{$tc('minutes', agent.timeTransfert, { count: agent.timeTransfert})}}
                    <br />
                    {{ $t('descriptionDelaiTransfert') | cap }}
                    </v-subheader>
                  </v-flex>
                  <v-flex xs12>
                    <v-slider
                      min="0" 
                      max="60"
                      step="1"
                      ticks
                      tick-size=2
                      v-model="agent.timeTransfert"
                      thumb-label
                      hide-details
                    ></v-slider>
                  </v-flex>
                </v-layout>
                </span>

                <span>
                <v-layout row wrap v-if="!isAdmin(agent.rights)">
                  <v-flex xs12>
                    <v-subheader>Temps de travail par jour : {{$tc('hours', agent.tempsTravail, { count: agent.tempsTravail })}}
                    <br />
                    {{ $t('descriptionDelaiTempsTravail') | cap }}
                    </v-subheader>
                  </v-flex>
                  <v-flex xs12>
                    <v-slider
                      min="2" 
                      max="16"
                      step="0.5"
                      ticks
                      tick-size=2
                      v-model="agent.tempsTravail"
                      thumb-label
                      hide-details
                    ></v-slider>
                  </v-flex>
                </v-layout>
                </span>

                <span>
                <v-layout row wrap v-if="!isAdmin(agent.rights)">
                  <v-flex xs12>
                    <v-subheader>Jours ouvrés par semaine : {{$tc('days', agent.jourHebdoTravail, { count: agent.jourHebdoTravail })}}
                    <br />
                    {{ $t('descriptionDelaiTempsTravail') | cap }}
                    </v-subheader>
                  </v-flex>
                  <v-flex xs12>
                    <v-slider
                      min="1" 
                      max="7"
                      step="1"
                      ticks
                      tick-size=2
                      v-model="agent.jourHebdoTravail"
                      thumb-label
                      hide-details
                    ></v-slider>
                  </v-flex>
                </v-layout>
                </span>

                <v-layout row wrap v-if="!isAdmin(agent.rights)">
                  <v-flex xs12>
                    <v-subheader>{{$t('priority') + ' (0 = normal, 10 = fort)' | cap }} : {{ agent.priority }}</v-subheader>
                  </v-flex>
                  <v-flex xs12>
                    <v-slider
                      :disabled="testBrideStatus('compte_conseillers_prioritaire')"
                      min="0"
                      max="10"
                      ticks
                      v-model="agent.priority"
                      thumb-label
                      hide-details
                    ></v-slider>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      :disabled="testBrideStatus('compte_conseillers_api')"
                      v-model="agent.keywords"
                      :label="'Tag / ' + $t('keywords') | cap"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      :disabled="testBrideStatus('compte_conseillers_black_list')"
                      v-model="agent.parturl"
                      :label="'White List' | cap"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      :disabled="testBrideStatus('compte_conseillers_black_list')"
                      v-model="agent.partnourl"
                      :label="'Black List' | cap"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="!isAdmin(agent.rights)">
                  <v-flex xs12>
                    <v-switch
                      :disabled="testBrideStatus('compte_conseillers_indispo')"
                      v-model="agent.canBeUnavailable"
                      :label="$t('canBeUnavailable') | cap"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="!isAdmin(agent.rights)">
                  <v-flex xs12>
                    <v-switch
                      :disabled="testBrideStatus('compte_conseillers_notifbo')"
                      v-model="agent.notifBo"
                      :label="$t('notification') | cap"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </div>  
                <div class="text-xs-right">
                  <v-btn color="primary" @click="submit()" right>
                    {{ $t('save') | cap }}
                    <v-icon dark right>send</v-icon>
                  </v-btn>
                </div>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      
      <!-- Ajout d'un agent -->
      <v-fab-transition>
        <!-- <v-tooltip left> -->
          <v-btn
            fab
            bottom
            floating
            fixed
            raised
            right
            dark
            color="secondary"
            class="white--text"
            slot="activator"
            @click.stop="openDialogCreate"
            v-show="!loading"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <!-- <span>{{ $t('add') | cap }} {{ $tc('agents', 1, { count: '' }) }}</span>
        </v-tooltip> -->
      </v-fab-transition>

      <!-- DIALOGUE -->
      <v-dialog persistent v-model="showDialogCreate" max-width="290">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon dark>person_add</v-icon>
            <span class="title pl-2">{{ $t('add') | cap }} {{ $tc('agents', 1, { count: '' }) }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              autofocus
              :label="$t('firstName') | cap"
              v-model="newAgentDialog.fname"
              counter 
              required
              max="20" 
              v-validate="'required|max:20'" 
              @keyup.enter="submitDialogCreate"
            ></v-text-field>
           <v-text-field
              autofocus
              :label="$t('lastName') | cap"
              v-model="newAgentDialog.lname"
              counter 
              max="20" 
              v-validate="'max:20'" 
              @keyup.enter="submitDialogCreate"
            ></v-text-field>
           <v-text-field
              autofocus
              :label="$t('loginEmail') | cap"
              v-model="newAgentDialog.email"
              counter 
              required
              max="30" 
              type="email" 
              @keyup.enter="submitDialogCreate"
            ></v-text-field>
            <v-text-field
              autofocus
              :label="$t('password') | cap"
              v-model="newAgentDialog.pwd"
              counter 
              required
              max="20" 
              type="password" 
              v-validate="'required|max:20'" 
              @keyup.enter="submitDialogCreate"
            ></v-text-field>
              <v-select
              :label="$tc('rights', 2, { count: '' }) | cap"
              v-model="newAgentDialog.rights"
              :items="rights">
              </v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loadingPost" flat @click="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
            <v-btn :loading="loadingPost" color="primary" flat @click="submitDialogCreate">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- dialog progress bar installation -->
    <wz-dialog-progress
      @fermeDialogProgress="fermeDialogProgress"
      :dialogProgress="dialogProgress"
      :etape=11
    >
    </wz-dialog-progress>
  </div>
</template>

<style>
.v-expansion-panel__header {margin-left: 16px;}
.v-input--slider {margin-bottom: 20px; margin-top: 0px !important;}
/*.btn_copierBulleChat{margin:0; position: absolute; top: 12px; right: 6px;}*/
</style>

<script>
import _ from 'lodash'
import { DOMAINE } from '../../constants'
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      domaine: DOMAINE,
      /**
      * indique si une requête ajax en cours
      * @type {Boolean}
      */
      loading: false,
      /**
       * affiche/cache la fenetre de dialog de création
       * @type {Boolean}
       */
      showDialogCreate: false,
      newAgentDialog: {rights: 1},
      name: 'Gestion des conseillers',
      /**
       * Liste des agents affichés
       * @type {Array}
       */
      agents: [],
      resAjx: null,
      rights: [
          { text: 'Conseiller simple', value: 1 },
          { text: 'Super Agent', value: 2 },
          { text: 'Administrateur', value: 3 }
      ],
      listAgent: [],
      loadingPost: false,
      dialogProgress: false
    }
  },

  mounted () {
    if (this.$store.state._User.entId === '5') {
      this.rights.push({ text: 'Admin Watcheezy', value: 999 })
    }
    this.loading = true
    this.axios.get('get/agents.php')
    .then(response => {
      this.resAjx = response.data
      this.init()
    })
    .catch()
    .then(_ => {
      this.loading = false
    })
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress()
    }
  },

  computed: {
    ...mapState('_User', ['brides']),
    ...mapGetters('_User', ['level']),
    agentsActivated () {
      return _.sumBy(this.agents, u => {
        return u.activity && !this.isAdmin(u.rights)
      })
    },

    hasOneSuper () {
      return _.filter(this.agents, u => u.rights === 2).length > 0
    }
  },
  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'management_conseillers'
    }    
      else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'management_conseillers'
        }
      }, 800);
    }
    /* eslint-enable */
  },
  methods: {
    ...mapMutations('_User', ['addColleague']),

    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },
    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
    },

    gotofilters () {
      window.alert('Redirection vers la page des filtres')
    },

    init () {
      for (var id in this.resAjx) {
        let parturlon = this.resAjx[id][0].USR_SITE_LIST
        let parturloff = this.resAjx[id][0].USR_NONSITE_LIST
        if (this.resAjx[id][0].USR_SITE_LIST.indexOf('|') !== -1) {
          let arrayOfStrings = this.resAjx[id][0].USR_SITE_LIST.split('|')
          parturlon = arrayOfStrings[0]
          parturloff = arrayOfStrings[1]
          if (!parturloff || parturloff === '') {
            parturloff = this.resAjx[id][0].USR_NONSITE_LIST
          }
        }
        this.agents.push({ id: this.resAjx[id][0].USR_ID,
          name: _.trim(this.resAjx[id][0].USR_FIRST_NAME + ' ' + this.resAjx[id][0].USR_LAST_NAME),
          firstname: this.resAjx[id][0].USR_FIRST_NAME,
          lastname: this.resAjx[id][0].USR_LAST_NAME,
          job: this.resAjx[id][0].USR_JOB,
          activity: this.resAjx[id][0].USR_ACTIVITY,
          email: this.resAjx[id][0].USR_MAIL_CONTACT,
          chatmax: this.resAjx[id][0].USR_NB_CHAT_MAX,
          priority: this.resAjx[id][0].USR_PRIORITY,
          keywords: this.resAjx[id][0].USR_KEYWORDS,
          parturl: parturlon,
          partnourl: parturloff,
          rights: _.toInteger(this.resAjx[id][0].USR_RIGHTS),
          notifonoff: this.resAjx[id][0].USR_CHAT_NOTIF_ONOFF === '1',
          closechatonoff: this.resAjx[id][0].USR_CLOSECHAT_ONOFF === '1',
          closechataction: this.resAjx[id][0].USR_CLOSECHAT_ACTION,
          closechatdetails: this.resAjx[id][0].USR_CLOSECHAT_DETAILS,
          filterlist: this.resAjx[id][0].USR_FIL_LIST.length,
          canBeUnavailable: this.resAjx[id][0].USR_CAN_UNAVAILABLE === '1',
          timeTransfert: this.resAjx[id][0].USR_TIME_TRANSFERT,
          tempsTravail: this.resAjx[id][0].USR_TIME_DAY,
          jourHebdoTravail: this.resAjx[id][0].USR_DAY_HEBDO,
          isbot: this.resAjx[id][0].USR_IS_BOT !== '',
          botid: this.resAjx[id][0].USR_IS_BOT,
          notifBo: this.resAjx[id][0].USR_BO_NOTIF === '1'
        })
      }
    },
    /**
     *  Valide le formulaire et update la BDD et le fichier XML pour le front
     */
    submit () {
      // il doit y avoir au moins un super agent
      if (!this.hasOneSuper) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure') + ' : ' + this.$t('atLeastOneSuper'), context: 'error' })
        return
      }
      // il doit y avoir au moins un user actif
      if (this.agentsActivated < 1) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure') + ' : ' + this.$t('atLeastOneActivated'), context: 'error' })
        return
      }
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      dataToPost.append('agents', JSON.stringify(this.agents))
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)

      // si cette étape est encore dans le tableau
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_MANAGEMENT_CONSEILLERS')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_MANAGEMENT_CONSEILLERS'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      this.axios.post('post/agents.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(error => {
        let message = error.response.data
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: `${this.$t('modifFailure')} ${this.$t(message)}`, context: 'error' })
      })
      .then(_ => {})
    },

    /**
     * ouvre la fenêtre de dialogue et initialise une nouvelle bibliothèque à créer
     */
    openDialogCreate () {
      this.showDialogCreate = true
    },
    /**
     * valide la nouvelle bibliothèque à créer
     */
    submitDialogCreate () {
      if (_.isEmpty(this.newAgentDialog.email) || this.newAgentDialog.email.indexOf('@') === -1) {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationFailure'), context: 'error' })
        return
      }
      // Données modifiées et à renvoyer
      this.loadingPost = true
      let dataToPost = new window.FormData()
      dataToPost.append('newagent', JSON.stringify(this.newAgentDialog))
      dataToPost.append('licenceLevel', this.level.rights)

      this.axios.post('post/newagent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        let colleague = {
          USR_FIRST_NAME: this.newAgentDialog.fname,
          USR_ID: response.data.id,
          USR_LAST_NAME: this.newAgentDialog.lname,
          USR_MAIL: this.newAgentDialog.email,
          USR_MAIL_CONTACT: this.newAgentDialog.email
        }
        this.addColleague(colleague)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationSuccess'), context: 'success' })
      })
      .catch(error => {
        let message = error.response ? error.response.data : ''
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: `${this.$t('creationFailure')} ${this.$t(message)}`, context: 'error' })
      })
      .then(_ => {
        this.showDialogCreate = false
        this.loadingPost = false
        this.axios.get('get/agents.php')
        .then(response => {
          this.resAjx = response.data
          this.agents = []
          this.init()
        })
        .catch()
        .then(_ => {})
      })
    },

    isAdmin (rights) {
      return rights === 3
    },

    isItMe (id) {
      return this.$store.state._User.id === id
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/management/Agents.vue